import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ComponentFactoryResolver,
  ViewChild
} from "@angular/core";
import { UcdComponent } from "./ucd-container/ucd.component";
import { GenericComponent } from "./generic-container/generic.component";

@Component({
  selector: "load-template",
  templateUrl: "./load-template.html"
})
export class LoadtempComponent implements OnInit {
  @ViewChild("container", { read: ViewContainerRef }) viewContainerRef;

  @Input() htmlTemp: any;
  @Input() tData: any;
  @Input() redesign: boolean;
  private templateMap = {
    "./ucd-templates/template-ucd.html": UcdComponent,
    "./ucd-templates/template-generic.html": GenericComponent
  };

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {
    this.loadDynamicTemplate();
  }

  private loadDynamicTemplate() {
    const templateName = this.htmlTemp;
    const templateComponent = this.templateMap[templateName];
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      templateComponent
    );
    const componentRef = this.viewContainerRef.createComponent(
      componentFactory
    );
    componentRef.instance.compData = this.tData;
    componentRef.instance.redesign = this.redesign;
  }
}
